import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Achizitii/ContracteModels.cs ----------

export type SupplierContractType = 'CadruPret' | 'AngajamentVolum' | 'Servicii' | 'Mentenanta'
export type SupplierContractStatus = 'Draft' | 'PendingApproval' | 'Activ' | 'Expirat' | 'Reziliat'

export interface SupplierContractLine {
  id: string | null
  articleId: string
  articleCode: string
  articleDescription: string
  negotiatedPrice: number
  currency: string
  unitOfMeasureId: string
  unitOfMeasureCode: string
  validFrom: string
  validTo: string | null
  committedQuantity: number | null
  consumedQuantity: number
  isCurrent: boolean
}

export type SaveSupplierContractLinePayload = Pick<
  SupplierContractLine, 'articleId' | 'negotiatedPrice' | 'currency' | 'unitOfMeasureId' | 'validFrom' | 'committedQuantity'
>

export interface SupplierContractListItem {
  id: string
  number: string
  supplierId: string
  supplierName: string
  type: SupplierContractType
  startDate: string
  endDate: string
  status: SupplierContractStatus
  isExpiringSoon: boolean
}

export interface SupplierContractDetail {
  id: string
  number: string
  supplierId: string
  supplierName: string
  type: SupplierContractType
  startDate: string
  endDate: string
  currency: string
  paymentTerms: string | null
  deliveryTerms: string | null
  notes: string | null
  status: SupplierContractStatus
  leadTimeDaysGuaranteed: number | null
  maintenanceResponseTimeHours: number | null
  isExpiringSoon: boolean
  isVolumeNearExhaustion: boolean
  lines: SupplierContractLine[]
  attachmentFileName: string | null
}

export interface SaveSupplierContractPayload {
  supplierId: string
  type: SupplierContractType
  startDate: string
  endDate: string
  currency: string
  paymentTerms: string | null
  deliveryTerms: string | null
  notes: string | null
  leadTimeDaysGuaranteed: number | null
  maintenanceResponseTimeHours: number | null
  lines: SaveSupplierContractLinePayload[]
}

export const listContracts = () => api.get<SupplierContractListItem[]>('/achizitii/contracte').then((r) => r.data)
export const getContract = (id: string) => api.get<SupplierContractDetail>(`/achizitii/contracte/${id}`).then((r) => r.data)
export const createContract = (payload: SaveSupplierContractPayload) =>
  api.post<{ id: string }>('/achizitii/contracte', payload).then((r) => r.data)
export const updateContract = (id: string, payload: SaveSupplierContractPayload) => api.put(`/achizitii/contracte/${id}`, payload)
export const addContractLine = (id: string, payload: SaveSupplierContractLinePayload) => api.post(`/achizitii/contracte/${id}/linii`, payload)
export const submitContractForApproval = (id: string) =>
  api.post<{ pendingApproval: boolean }>(`/achizitii/contracte/${id}/submit-aprobare`).then((r) => r.data)
export const terminateContract = (id: string) => api.post(`/achizitii/contracte/${id}/reziliaza`)

export const uploadContractDocument = (id: string, file: File) => {
  const form = new FormData()
  form.append('file', file)
  return api.post(`/achizitii/contracte/${id}/document`, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export const getContractDocument = (id: string) =>
  api.get<Blob>(`/achizitii/contracte/${id}/document`, { responseType: 'blob' }).then((r) => r.data)
